import { User } from '../user.interface';

export interface NewsLike {
    id: number;
    news_id: number;
    user_id: number;
    created_at: Date;
    user: User;
    type: NewsLikeType;
}

export enum NewsLikeType {
    leuk = 'leuk',
    geweldig = 'geweldig',
    nieuwsgierig = 'nieuwsgierig',
    bezorgd = 'bezorgd',
    niet_leuk = 'niet leuk',
}
